import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from '@plone/volto/helpers';
import Logo from 'volto-gforce/components/Logo';
import { NAV, QUOTE } from 'volto-gforce/components/nav';

const GF_JSONLD = "{\"@context\": \"https://schema.org\", \"@graph\": [{\"@type\": \"Organization\", \"@id\": \"https://gforcepromo.com/#organization\", \"name\": \"GForce Promotions\", \"legalName\": \"GForce Promotions, LLC\", \"url\": \"https://gforcepromo.com/\", \"logo\": {\"@type\": \"ImageObject\", \"url\": \"https://gforcepromo.com/icon-512.png\", \"width\": 512, \"height\": 512}, \"sameAs\": [\"https://www.linkedin.com/company/gforce-promo\", \"https://www.instagram.com/gforcepromo\"]}, {\"@type\": \"WebSite\", \"@id\": \"https://gforcepromo.com/#website\", \"name\": \"GForce Promotions\", \"url\": \"https://gforcepromo.com/\", \"publisher\": {\"@id\": \"https://gforcepromo.com/#organization\"}, \"inLanguage\": \"en-US\"}]}";

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);
  const close = () => setOpen(false);
  return (
    <>
    <Helmet
      titleTemplate={location.pathname === '/' || location.pathname === '' ? '%s' : '%s | GForce Promotions'}
      defaultTitle="GForce Promotions"
    >
      <meta property="og:image" content="https://gforcepromo.com/og-image.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="GForce Promotions" />
      <link rel="icon" type="image/png" sizes="48x48" href="/favicon-48x48.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/favicon-192x192.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content="https://gforcepromo.com/og-image.jpg" />
      {(location.pathname === '/' || location.pathname === '') && (
        <script type="application/ld+json">{GF_JSONLD}</script>
      )}
    </Helmet>
    <header className={`gf-header${open ? ' gf-menu-open' : ''}`} role="banner">
      <div className="gf-wrap">
        <nav className="gf-nav" aria-label="Main">
          <Link to="/" className="gf-logo-link" aria-label="GForce Promotions home" onClick={close}>
            <Logo variant="black" />
          </Link>
          <ul>
            {NAV.map((i) => (
              <li key={i.href}><Link to={i.href}>{i.title}</Link></li>
            ))}
            <li className="gf-nav-cta"><Link to={QUOTE.href} className="gf-btn gf-btn-dark">{QUOTE.title}</Link></li>
          </ul>
          <button
            type="button"
            className="gf-burger"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            aria-controls="gf-mobile-menu"
            onClick={() => setOpen(!open)}
          >
            <span /><span /><span />
          </button>
        </nav>
      </div>
      <div id="gf-mobile-menu" className="gf-mobile-menu" hidden={!open}>
        <ul>
          {NAV.map((i) => (
            <li key={i.href}><Link to={i.href} onClick={close}>{i.title}</Link></li>
          ))}
          <li><Link to={QUOTE.href} className="gf-btn gf-btn-dark" onClick={close}>{QUOTE.title}</Link></li>
        </ul>
      </div>
    </header>
    </>
  );
};
export default Header;
